import * as React from 'react';
import ReactDom   from 'react-dom';

export async function initMaps() {
  const [ymaps3React, ymaps3Controls] = await Promise.all([
    ymaps3.import('@yandex/ymaps3-reactify'),
    ymaps3.import('@yandex/ymaps3-controls@0.0.1'),
    ymaps3.ready,
  ]);

  const reactify = ymaps3React.reactify.bindTo(React, ReactDom);

  return {
    ...reactify.module(ymaps3),
    ...reactify.module(ymaps3Controls),
    reactify,
  };
}

export default initMaps;